var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"boxEl",class:!!_vm.fill ? 'xq-svg-box' : 'non-fill',attrs:{"id":"svg-snap"}})
}
var staticRenderFns = []

export { render, staticRenderFns }